import { CounterpartyOrderModuleSchema, Module, WarehouseDocumentPlace } from '@app/models/orders';

import { CounterpartyOrderRow } from '../interfaces';

type PlaceType = 'pallet' | 'box';

const PLACE_TYPES: Record<string, PlaceType> = {
  палет: 'pallet',
  палета: 'pallet',
  паллет: 'pallet',
  паллета: 'pallet',
  pallet: 'pallet',
  короб: 'box',
  коробка: 'box',
  box: 'box',
};

export const getPlaceType = (type: string): PlaceType | undefined => PLACE_TYPES[type.trim().toLowerCase()];

export const sumPlaces = (places: WarehouseDocumentPlace[]): number =>
  places.reduce((sum, place) => sum + place.amount, 0);

const DECIMAL_PATTERN = /^-?\d+(\.\d+)?$/;

export const formatDecimal = (value: string | null | undefined, locale: string): string => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  if (!DECIMAL_PATTERN.test(value)) {
    return value;
  }

  const [integer, fraction = ''] = value.split('.');
  const digits = fraction.replace(/0+$/, '');
  const formatter = new Intl.NumberFormat(locale);
  const separator = formatter.formatToParts(1.5).find((part) => part.type === 'decimal')?.value || '.';
  const grouped = formatter.format(Number(integer));

  return digits ? `${grouped}${separator}${digits}` : grouped;
};

export const getRowModules = (row: CounterpartyOrderRow): CounterpartyOrderModuleSchema[] =>
  'modules' in row ? row.modules : [{ module: Module.Warehouse, status: row.status }];
